var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 16,
    height: 20,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    rx: 0.5,
    transform: "matrix(1 0 0 -1 3.5 2)",
    fill: "#0047FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 6,
    rx: 1,
    transform: "matrix(1 0 0 -1 3.5 8.60156)",
    fill: "#0047FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 1.4,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 3.90039 10.7969)",
    fill: "#0047FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 1.4,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 8.30078 10.7969)",
    fill: "#0047FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 1.4,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 12.7012 10.7969)",
    fill: "#0047FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 3.90039 13.3984)",
    fill: "#0047FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 8.30078 13.3984)",
    fill: "#0047FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 12.7012 13.3984)",
    fill: "#0047FF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 3.90039 16)",
    fill: "#0047FF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 8.30078 16)",
    fill: "#0047FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 12.7012 16)",
    fill: "#0047FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 3.90039 18.6016)",
    fill: "#0047FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 8.30078 18.6016)",
    fill: "#0047FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 2,
    rx: 0.4,
    transform: "matrix(1 0 0 -1 12.7012 18.6016)",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.09c022a8fd5c96989cc6ef31b33bd2a8.svg";
export { ForwardRef as ReactComponent };